<template>
  <v-hover>
    <template v-slot:default="{ hover }">
      <!-- <v-avatar size="300px" > -->
      <v-card
        flat
        striped
        exact
        max-width="272"
        max-height="272"
     
        :to="{ name: 'Details', params: { name: name } }"
      >
        <template slot="progress">
          <v-progress-circular
            :size="70"
            :width="7"
            color="purple"
            indeterminate
          ></v-progress-circular>
        </template>
        <ImageCard :imageName="imgName" :alt="name" parentFolder="team" />
        <v-expand-transition>
          <v-overlay opacity=".9" v-if="hover" absolute color="#000">
            <v-card-title>
              {{ name }}
            </v-card-title>
            <v-card-text>
              {{ job }}
            </v-card-text>
          </v-overlay>
        </v-expand-transition>
      </v-card>
      <!-- </v-avatar> -->
    </template>
  </v-hover>
</template>

<script>
import ImageCard from "@/components/global/ImageCard";
export default {
  components: { ImageCard },
  data: () => ({
    overlay: false,
    loading: false,
  }),
  props: {
    name: {
      type: String,
    },
    job: {
      type: String,
    },
    imgName: {
      type: String,
    },
  },
};
</script>